import React, { useEffect } from 'react';
import '../CSS/Exam.css';
import { Link } from 'react-router-dom';

const EXAMS = [
  {
    title: 'IIT JEE (Mains & Advanced)',
    badge: 'Engineering',
    img: require('../assets/iitjeelogo.jpg'),
    desc: 'Joint Entrance Examination for admission to IITs, NITs, and top engineering institutes.',
    highlights: ['2-stage exam: JEE Mains → JEE Advanced', 'Subjects: Physics, Chemistry, Mathematics', 'NGT provides 2-year intensive coaching'],
  },
  {
    title: 'NEET — National Eligibility cum Entrance Test',
    badge: 'Medical',
    img: require('../assets/neetlogo.jpeg'),
    desc: 'Unified entrance test for MBBS, BDS, and other medical courses across India.',
    highlights: ['Subjects: Physics, Chemistry, Biology', 'NGT coaching aligns with NCERT + NTA pattern', 'Regular mock tests and doubt sessions'],
  },
  {
    title: 'MH-CET — Maharashtra Common Entrance Test',
    badge: 'State',
    img: require('../assets/CET1.png'),
    desc: 'State-level entrance for engineering and pharmacy colleges in Maharashtra.',
    highlights: ['Physics, Chemistry, Maths (PCM) stream', 'Conducted by State CET Cell', 'NGT provides targeted practice and revision'],
  },
  {
    title: 'SSC Board Examination',
    badge: 'Board',
    img: require('../assets/cbselogo.png'),
    desc: 'Maharashtra State Board exam for Grade X — the foundation for all future streams.',
    highlights: ['All subjects including Science, Maths, Social Science', 'Extensive coverage of SSC board syllabus', 'Previous year paper practice included'],
  },
  {
    title: 'CBSE Grade X & XII',
    badge: 'CBSE',
    img: require('../assets/cbselogo.png'),
    desc: 'Central Board of Secondary Education exams covering Class V through XII.',
    highlights: ['Science, Social Science, Mathematics, English', 'NCERT-based curriculum coverage', 'Sample papers, term tests, and board prep'],
  },
];

const Exam = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <div className="ngt-page-banner">
        <h1>Examination Coaching</h1>
        <p>Comprehensive preparation for board exams and national competitive examinations</p>
      </div>
      <nav aria-label="breadcrumb" className="container mt-3">
        <ol className="breadcrumb" style={{ fontSize: '0.85rem' }}>
          <li className="breadcrumb-item"><a href="/">Home</a></li>
          <li className="breadcrumb-item active">Exams</li>
        </ol>
      </nav>
      <section className="ngt-exam-page">
        <div className="container">
          <h2 className="section-title">Examinations We Prepare For</h2>
          <p className="section-subtitle">Structured coaching mapped to the latest exam patterns and syllabi</p>
          <div className="row g-4">
            {EXAMS.map((exam, i) => (
              <div key={i} className="col-md-6 col-lg-4">
                <div className="ngt-exam-card h-100">
                  <span className="exam-badge">{exam.badge}</span>
                  <h4 className="mt-2">{exam.title}</h4>
                  <p style={{ color: 'var(--ngt-grey)', fontSize: '0.92rem', marginBottom: '1rem' }}>{exam.desc}</p>
                  <ul>
                    {exam.highlights.map((h, j) => <li key={j}>{h}</li>)}
                  </ul>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-5">
            <Link to="/enquiry" className="btn-ngt-primary" style={{ padding: '13px 40px', fontSize: '1rem' }}>
              <i className="fas fa-phone me-2"></i> Enquire About Coaching
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Exam;
